import DeputyList from "./ManageReserveDeputy/DeputyList";
import CheckPointList from "./ManageCheckPoints/CheckPointList";

const ReserveDeputyBase = () => {
  return (
    <div className="">
      <DeputyList />
    </div>
  );
};

export default ReserveDeputyBase;
